export default __webpack_public_path__ + "static/cashflow_new_3-41905ef85eb5fe5344a40a6e6b68c518.jpg";